import * as React from 'react';
import { IQuickLookProps } from './types';
import { CARD_CLASS, CARD_CONTROL_CLASS, LIST_CONTAINER_CLASS } from '../../../../constants';
import './_QuickLook.scss';
import { Button, Icon, Loader } from 'kui';
import { SHOW_LESS, SHOW_MORE } from '../../../../wording';
import { PADDING, QUICK_LOOK_MAX_HEIGHT } from './constants';
import { root } from 'app/store/constants';
import { AnalyzeRender } from 'app/view/react_components/helpers/memoizeHelper';
import { EQuickLookType } from 'app/view/react_components/main/kanbanView/components/Card/components/Card/types';

const analyzeRender = root.Settings.development ? new AnalyzeRender(`QuickLook`) : null;

export function QuickLook({
    cardId,
    component,
    isCollapse,
    isClone,
    isNeedCollapse,
    openedQuickLook,
    onToggleQuickLookCollapse,
    setNeedCollapse,
}: IQuickLookProps) {

    if (analyzeRender) analyzeRender.call(cardId, arguments[0]);

    const className = CARD_CLASS + '__quick-look';
    const classContent = className + '-content';

    const ref = React.useRef(null);

    const toggleShowMore = () => {
        onToggleQuickLookCollapse();
    };

    const isDescription = openedQuickLook === EQuickLookType.DESCRIPTION;

    const debounce = React.useRef(null);
    const checkNeedCollapse = () => {
        if (!isDescription) {
            setNeedCollapse(false);
            return;
        }
        if (debounce.current) clearTimeout(debounce.current);
        debounce.current = setTimeout(() => {
            if (ref.current) {
                let isNeedCollapse = ref.current.scrollHeight > QUICK_LOOK_MAX_HEIGHT;
                setNeedCollapse(isNeedCollapse);
                if (isCollapse === undefined && isNeedCollapse) {
                    onToggleQuickLookCollapse();
                }
            }
        }, 50);
    }

    React.useEffect(() => {
        if (isClone) {
            checkNeedCollapse();
        }
    }, [openedQuickLook]);

    React.useEffect(() => {
        return () => {
            if (debounce.current) clearTimeout(debounce.current);
        }
    }, []);

    if (!isClone && isNeedCollapse === undefined) return null; // ждем пока клон отрисует

    React.useEffect(() => {
        if (isClone) return;

        const lessButton = ref.current.querySelector('.k-card__quick-look-less') as HTMLElement;
        const button = ref.current.querySelector('.k-card__control') as HTMLElement;
        const listContainer = ref.current.closest('.k-card__container') as HTMLElement;
        const listComponent = ref.current.closest('.list-component') as HTMLElement;
        if (!listComponent) return;
        let observer = new IntersectionObserver(([e]) => {
            if (e.intersectionRatio === 1) {
                listComponent.style.paddingBottom = PADDING;
                if (lessButton) lessButton.style.bottom = PADDING;
            } else {
                listComponent.style.paddingBottom = 'unset';
                if (lessButton) lessButton.style.bottom = '0';
            }
        }, {
            root: listContainer,
            threshold: [0, 1],
            rootMargin: '0px 0px -20px 0px'
        });
        if (button) {
            if (lessButton) {
                observer.observe(lessButton);
            } else {
                listComponent.style.paddingBottom = 'unset';
                button.style.bottom = '0';
                observer.disconnect();
            }
        }
        return () => observer.disconnect();
    }, [isCollapse])

    return (
        <div
            className={`
                ${className}
                ${(isNeedCollapse || !isDescription)
                    ? className + '--' + (isCollapse && isDescription ? 'collapsed' : 'expanded') : ''
                }
            `}
            ref={ref}
        >
            <div className={classContent}>
                    {component}
                    {isNeedCollapse && isDescription &&
                        <div
                            className={`
                                    ${!!isCollapse ? className + '-more' : className + '-less'}
                                    ${CARD_CONTROL_CLASS}
                                `}
                        >
                            <Button
                                variant={'icon-text'}
                                text={!!isCollapse ? SHOW_MORE : SHOW_LESS}
                                onClick={toggleShowMore}
                            >
                                <Icon
                                    xlink={!!isCollapse ? 'arrow-s-drop-open' : 'arrow-s-drop-close'}
                                    size={24}
                                />
                            </Button>
                        </div>
                    }
                </div>
        </div>
    );
}
